import { render, staticRenderFns } from "./ModalCar.vue?vue&type=template&id=b0acd8cc&"
import script from "./ModalCar.vue?vue&type=script&lang=js&"
export * from "./ModalCar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports